var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxRadioGroup',{attrs:{"items":[{ id: 1 }],"valueExpr":"id","value":_vm.setValue == 'Y' ? 1 : null,"onValueChanged":_vm.radioValueChange,"disabled":_vm.disabled,"elementAttr":{ class: 'gc-field-radio-wrapper' }}})}
var staticRenderFns = []

export { render, staticRenderFns }